import { CreateUserData, ExtendedUser } from "../store/types";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email: string): boolean => {
  if (!email) return false;

  return EMAIL_REGEX.test(email);
};

export const isNotEmpty = (value: string): boolean => {
  return value.trim().length > 0;
};

export const isPatronymic = (value: string): boolean => {
  return value.trim().length > 0 || value === "";
};

export const isAlphanumeric = (value: string): boolean => {
  const regex = /^[a-z_]+$/;
  return regex.test(value);
};

export const validatePhone = (phone: string): boolean => {
  if (phone === "") return true;
  else if (!phone) return false;

  const digits = phone.replace(/\D/g, "");
  return digits.length === 10;
};

export const formatPhone = (phone: string) => {
  if (phone == null) return "";
  const phoneStr = String(phone);
  const cleaned = phoneStr.replace(/\D/g, "");
  if (cleaned.length === 11) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(
      7,
      9
    )}-${cleaned.slice(9, 11)}`;
  }
  if (cleaned.length === 10) {
    return `+7 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6,
      8
    )}-${cleaned.slice(8, 10)}`;
  }
  return phoneStr;
};

export const validateField = (
  field: keyof CreateUserData,
  value: any
): boolean => {
  switch (field) {
    case "lastName":
    case "name":
    case "patronymic":
      return isPatronymic(value ?? "");
    case "email":
      return validateEmail(value ?? "");
    case "phone":
      return validatePhone(value ?? "");
    case "organizationId":
      return typeof value === "number" && value > -1;
    default:
      return true;
  }
};

export const validateLicenseField = (field: string, value: any): boolean => {
  switch (field) {
    case "numberOfLicenses":
      return typeof value === "number" && value > 0;
    case "type":
    case "projectId":
    case "organizationId":
      return value !== null && value !== undefined;
    case "startDate":
    case "expirationDate":
      return value instanceof Date && !isNaN(value.getTime());
    default:
      return true;
  }
};

export const isUserFormValid = (data: {
  lastName: string;
  name: string;
  patronymic: string;
  email: string;
  phone: string;
  organizationId: string | number;
}): boolean => {
  const { lastName, name, patronymic, email, phone, organizationId } = data;

  if (
    !isNotEmpty(lastName) ||
    !isNotEmpty(name) ||
    !isNotEmpty(patronymic) ||
    !isNotEmpty(email) ||
    !isNotEmpty(phone)
  ) {
    return false;
  }

  if (!organizationId) return false;

  if (!validateEmail(email)) return false;

  if (!validatePhone(phone)) return false;

  return true;
};

export const isCompanyFormValid = (data: {
  name: string;
  email: string;
  phone: string;
}): boolean => {
  const { name, email, phone } = data;

  if (!isNotEmpty(name) || !isNotEmpty(email) || !isNotEmpty(phone)) {
    return false;
  }

  if (!validateEmail(email)) return false;
  if (!validatePhone(phone)) return false;

  return true;
};
